import ApiException from "@rmp/core/exceptions/apiException";

export default class HttpNotFoundException extends ApiException {
	constructor(public readonly url: string) {
		super(`HttpNotFoundException: ${url}`);
	}
}
